




export default {
  props: {
    square: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'red',
    },
    size: {
      type: String,
      default: '10',
    },
  },
  computed: {
    styles() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        backgroundColor: this.color,
      }
    },
  },
}
